
import styles from './Home.module.css'
import {useEffect,useState} from "react";
import NavBurgerMenu from "../ui/nav-burger-menu/NavBurgerMenu";
import {BsMouse} from "react-icons/bs";
import Socials from "../ui/socials/Socials";


const Home = () => {
    const [changingText,setChangingText] = useState('')


    useEffect(() => {
        const interval = ()=> {
            setChangingText('Developer');
            setTimeout(() => {
                setChangingText('Hardworking');
            }, 4000);
            setTimeout(() => {
                setChangingText('Creative');
            }, 8000);
        };

        interval();
        setInterval(interval, 12000);

    }, []);

    return (

         <section className={styles.home} id='home'>

             <div className={'relative'}>
                <NavBurgerMenu/>
                 <h1 className={styles.name}><span className='text-red-700'>David</span> Bogomolov</h1>
                 <div className={styles.wrapperText}>
                     <span className={`text-white ${styles.firstText}`}>I am a</span>
                     <span className={`text-red-700 ${styles.secondText} `}>{changingText}</span>
                 </div>
             </div>

             <div className={styles.mouseWrapper}>
                 <BsMouse className={styles.mouse}/>
                 <div className={styles.mouseLine}></div>
             </div>
             <Socials/>
            </section>
    )
}


export default Home